import React from "react";
import { Badge, Card, Col, Form, Row } from "react-bootstrap";
import { AdminUserModel } from "../../models/AccountPermissionModel";

interface IProps {
  num: number;
  edited: AdminUserModel;
  setEdited: React.Dispatch<React.SetStateAction<AdminUserModel>>;
}

const ROLES = ["admin", "manager", "publisher", "default"];

const AccountInfoCard = ({ num, edited, setEdited }: IProps) => {
  const set = (key: keyof AdminUserModel, value: string) => setEdited((prev) => ({ ...prev, [key]: value }));

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="bg-white d-flex align-items-center gap-2">
        <Badge bg="primary" pill>{num}</Badge>
        <span className="fw-bold">계정 정보</span>
        <span className="text-muted small">이름 · 역할</span>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Col md={4}>
            <Form.Label className="small fw-semibold">이름 <span className="text-danger">*</span></Form.Label>
            <Form.Control value={edited.name ?? ""} placeholder="예: 중국애니메이트" onChange={(e) => set("name", e.target.value)} />
          </Col>
          <Col md={4}>
            <Form.Label className="small fw-semibold">아이디(이메일)</Form.Label>
            <Form.Control className="font-monospace" value={edited.email} disabled />
          </Col>
          <Col md={4}>
            <Form.Label className="small fw-semibold">역할</Form.Label>
            <Form.Select value={edited.role} onChange={(e) => set("role", e.target.value)}>
              {ROLES.map((role) => <option key={role} value={role}>{role}</option>)}
            </Form.Select>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AccountInfoCard;
